import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (AuthService.isUserPhysician() || AuthService.isActiveMemberPhysician() || AuthService.isPracticeAncillary()) {
                return next({ name: 'practice.members' })
            }

            next()
        })
    },
}
